import React, { useState } from 'react';
import { Translate, useTranslate } from '@above-the-treeline/localization';
import { message } from 'antd';
import { useUser } from '../../../User/containers/UserDataStore';
import { useUserPreferences } from '../../../UserPreferences';
import {
	getInitialFormValuesById,
	getRowOptionsList,
} from './LinksInitializer';
import { getRowByType } from '../Form/Form';
import { FormId } from '../Form/FormId';

const Links = () => {
	const { translate } = useTranslate();
	const userDataStore = useUser();
	const userPreferences = useUserPreferences();
	const userAttributes = userPreferences.getUserAttributes();

	const rowOptionsList = getRowOptionsList();
	const initialFormValuesById = getInitialFormValuesById(userAttributes);

	const [formValuesById, setFormValuesById] = useState(initialFormValuesById);

	const getGoodReadsAuthUri = () =>
		`${process.env.REACT_APP_EPLUS_LINK_URL}
			/uc/OAuth/OAuthAuthorize.aspx?oAuthProvider=GOODREADS`;

	const saveLinks = async () => {
		const { id: appUserId } = userDataStore.state.user.user;
		const didSucceed = await userPreferences.saveLinks(
			formValuesById,
			appUserId,
		);
		if (didSucceed) {
			return message.success(translate('links_saved'));
		}
		message.error(translate('error_saving_links'));
	};

	const getLinkRowByType = rowOptions =>
		getRowByType(
			rowOptions,
			formValuesById,
			setFormValuesById,
			FormId.Links,
		);

	return (
		<div className="links">
			<div className="links-prompt">
				<Translate id="social_media_links_below_will_appear_in_profile" />
				:
			</div>
			{rowOptionsList.map(getLinkRowByType)}
			<div
				title={translate('save_links')}
				className="icon-save-icon plus"
				onClick={saveLinks}
			/>
			<div className="link-social-media-accounts">
				<span className="acc-font-no-hover link-accounts-label">
					<Translate id="link_your_goodreads_account" />:
				</span>
				<a
					target="_blank"
					rel="noreferrer noopener"
					href={getGoodReadsAuthUri()}
					className="icon-goodreads socialIcons socialLink"></a>
			</div>
		</div>
	);
};

export default Links;
